<!-- Botón disparador -->
<button
  type="button"
  (click)="open()"
  class="w-full px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors flex items-center justify-start gap-2 h-10 text-left">
  <i [class]="icon" class="text-sm"></i>
  <span class="text-sm flex-1 truncate">
    <ng-container *ngIf="selectedLabels && selectedLabels.length > 0">
      {{ selectionMode === 'single' ? selectedLabels[0] : selectedLabels.length + ' elementos' }}
    </ng-container>
    <ng-container *ngIf="!selectedLabels || selectedLabels.length === 0">
      {{ placeholder }}
    </ng-container>
  </span>
</button>

<!-- Modal -->
<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [style]="{width: '50rem'}"
  [draggable]="false"
  [resizable]="false"
  [header]="title">
  <!-- Toolbar -->
  <div class="flex flex-row justify-between items-center mb-4">
    <div class="inline-flex rounded-md -space-x-px" role="group">
      <button 
        type="button" 
        class="px-3 py-2 text-sm font-medium rounded-l-md border border-gray-300 bg-white hover:bg-gray-50"
        (click)="expandAll()">
        Expandir todo
      </button>
      <button 
        type="button" 
        class="px-3 py-2 text-sm font-medium border border-gray-300 bg-white hover:bg-gray-50"
        (click)="collapseAll()">
        Contraer Todo
      </button>
      <button 
        type="button" 
        class="px-3 py-2 text-sm font-medium border border-gray-300 bg-white hover:bg-gray-50"
        (click)="clear()">
        Limpiar
      </button>
    </div>
  </div>
  
  <!-- Tree -->
  <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-1 my-4">
    <p-tree
      [value]="treeNodes"
      class="w-full">
      <ng-template pTemplate="default" let-node>
        <div class="flex items-center justify-between w-full">
          <div class="flex items-center">
            <input 
              type="checkbox" 
              class="mr-2 accent-orange-600" 
              [checked]="isChecked(node.key)"
              (change)="toggleNode(node)" />
            <span 
              *ngIf="showSwatch && node.data?.color" 
              class="w-3 h-3 rounded-full mr-2"
              [style.background]="node.data?.color">
            </span>
            <span class="ml-2">{{ node.label }}</span>
          </div>
        </div>
      </ng-template>
    </p-tree>
  </div>
  
  <!-- Footer -->
  <ng-template pTemplate="footer">
      <p-button
        label="Cancelar"
        icon="pi pi-times"
        class="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded mr-2"
        (onClick)="close()">
      </p-button>
      <p-button
        label="Aplicar"
        icon="pi pi-check"
        class="bg-naranja hover:bg-orange-400 text-white font-bold py-2 px-4 rounded"
        (onClick)="apply()">
      </p-button>
    </ng-template>
</p-dialog>
